import { render, staticRenderFns } from "./ModalAdditionalFee.vue?vue&type=template&id=db33bc9e"
import script from "./ModalAdditionalFee.vue?vue&type=script&lang=js"
export * from "./ModalAdditionalFee.vue?vue&type=script&lang=js"
import style0 from "./ModalAdditionalFee.vue?vue&type=style&index=0&id=db33bc9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports